export default {
    state: {
      treeId: null,
      areaId:null,
      isTree:null,
      taskId:null
    },
    mutations: {
      setTreeId(state, data) {
        state.treeId = data;
      },
      setAreaId(state, data) {
        state.areaId = data;
      },
      setIsTree(state, data) {
        state.isTree = data;
      },
      setTaskId(state, data) {
        state.taskId = data;
      }
    },
    actions: {
      addTreeId({ commit }, data) {
        commit("setTreeId", data);
      },
      addAreaId({ commit }, data) {
        commit("setAreaId", data);
      },
      addIsTree({ commit }, data){
        commit("setIsTree", data);
      },
      addTaskId({ commit }, data){
        commit("setTaskId", data);
      }
    },
    getters: {
      getTreeId: state => state.treeId,
      getAreaId: state => state.areaId,
      getIsTree: state => state.isTree,
      getTaskId: state => state.taskId,
    }
  };
  